"use strict";
/**
 * A singleton class used to associate a click-outside callback event handler with multiple disparate components.
 * This is used in the case of a component with multiple stacked elements that are not parented to one another.
 *
 * When the user clicks outside of the subscribed nodes, the callback provided by the first subscribed component is called.
 * The callback is automatically reset once all nodes are unsubscribed.
 *
 * Components should subscribe on componentDidMount and unsubscribe on componentWillUnmount
 */
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalPointerDownOutsideListener = /** @class */ (function () {
    function GlobalPointerDownOutsideListener() {
    }
    GlobalPointerDownOutsideListener.subscribeOrUnsubscribeDocument = function (document, subscribe) {
        if (subscribe) {
            document.addEventListener('mousedown', this.handleClickAway.bind(this), true);
            document.addEventListener('touchstart', this.handleClickAway.bind(this), true);
        }
        else {
            document.removeEventListener('mousedown', this.handleClickAway.bind(this), true);
            document.removeEventListener('touchstart', this.handleClickAway.bind(this), true);
        }
        var iframes = document.getElementsByTagName('iframe');
        for (var i = 0; i < iframes.length; i++) {
            GlobalPointerDownOutsideListener.trySubscribeOrUnscribeDocument(iframes[i].contentDocument, subscribe);
        }
    };
    /**
     * We do a try/except because we may try to add event listeners to iframes that are not from the same source. If
     * that is the case we catch it and continue without adding the listeners.
     */
    GlobalPointerDownOutsideListener.trySubscribeOrUnscribeDocument = function (document, subscribe) {
        try {
            GlobalPointerDownOutsideListener.subscribeOrUnsubscribeDocument(document, subscribe);
        }
        catch (e) {
            /**
             * If the document is an iframe from a different source we can't add event listeners.
             * IE, Firefox, and Chrome seem to be throwing different exceptions, so this just assumes
             * that is the error being thrown.
             */
        }
    };
    GlobalPointerDownOutsideListener.subscribe = function (domNode, callback) {
        // TODO: Rework this so it's not implicit that a subscribing component's callback will be ignored if a callback is already registered
        if (!this.callback && callback) {
            this.callback = callback;
        }
        if (this.domNodes.length === 0) {
            GlobalPointerDownOutsideListener.trySubscribeOrUnscribeDocument(document, true);
        }
        this.domNodes.push(domNode);
        return function () {
            GlobalPointerDownOutsideListener.unsubscribe(domNode);
        };
    };
    GlobalPointerDownOutsideListener.unsubscribe = function (nodeToRemove) {
        this.domNodes = this.domNodes.filter(function (item) { return item !== nodeToRemove; });
        if (this.domNodes.length === 0) {
            this.callback = null;
            GlobalPointerDownOutsideListener.trySubscribeOrUnscribeDocument(document, false);
        }
    };
    GlobalPointerDownOutsideListener.handleClickAway = function (e) {
        if (!this.callback) {
            return;
        }
        var target = e.target;
        for (var _i = 0, _a = this.domNodes; _i < _a.length; _i++) {
            var node = _a[_i];
            if (node.contains(target)) {
                return;
            }
        }
        this.callback();
    };
    GlobalPointerDownOutsideListener.domNodes = [];
    return GlobalPointerDownOutsideListener;
}());
exports.GlobalPointerDownOutsideListener = GlobalPointerDownOutsideListener;
//# sourceMappingURL=GlobalPointerDownOutsideListener.js.map